export const ACTION_PREFIX = 'MODULE/PLAN'
